<script>
import ListPage from "@/components/list.vue";

export default {
  name: "NetList",
  components: {ListPage}
}
</script>

<template>
<list-page create-title="Create NET" update-title="Edit NET: " updateTitleKey="Address"/>
</template>

<style scoped>

</style>